// removed by extract-text-webpack-plugin
module.exports = {"Navigationitems":"NavigationItems_Navigationitems_3CIOs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 103
// module chunks = 3